import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { provideHttpClient } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { InputFieldComponent } from '@siat-fe/shared';
import { AuthRouting } from './auth.routing';
import { EntraAuthenticatorComponent } from './login/entra-authenticator/entra-authenticator.component';
import { EntraLoginButtonComponent } from './login/entra-authenticator/entra-login-button/entra-login-button.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AuthRouting,
    FormsModule,
    MatTooltipModule,
    InputFieldComponent,
    MatButtonModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    TranslatePipe,
    MatIcon,
  ],
  declarations: [
    LogoutComponent,
    LoginComponent,
    EntraAuthenticatorComponent,
    EntraLoginButtonComponent,
  ],
  providers: [provideHttpClient()],
})
export class AuthModule {}
